import React from "react";
import {Alert} from 'react-bootstrap';
import {connect} from 'react-redux';
import {hideAlert} from '../state/showAlert'
import {LanguageContext} from "../App";

class AlertWindow extends React.Component {
    constructor(props) {
        super(props);
        this.handleClose = () => {
            this.props.hideAlert();
        }
    }

    render() {
        let text = '';
        switch (this.props.alert) {
            case 'null-puzzle':
                text = 'info_rozwin_menu';
                break;
            case 'out-of-range':
                text = 'info_poza_zasiegiem';
                break;
            case 'drag-out-of-range':
                text = 'info_poza_zasiegiem_przesuniecie';
                break;
            case 'to-small-window':
                text = 'info-zamale-okno';
                break;
            default:
                return '';
        }

        return (
            <LanguageContext.Consumer>
                {({language}) =>
                    <div id="alertWindow">
                        <Alert bsStyle="warning" onDismiss={this.handleClose}>
                            <p style={{
                                'margin': '0',
                                'color': '#ffffff',
                                'fontFamily': 'Roboto, sans-serif'
                            }}>{language[text]}</p>
                        </Alert>
                    </div>
                }
            </LanguageContext.Consumer>
        );

    }
}

export default connect(
    state => ({
        alert: state.showAlert
    }),
    {hideAlert}
)(AlertWindow)



// WEBPACK FOOTER //
// ./src/WorkingSpace/AlertWindow.js